<template>
  <div class="pricePlain">
    <div class="info">
      <div>
        <span>优惠券:</span>
        <span>{{amount.amount}}元</span>
      </div>
      <div>
        <span>服务费:</span>
        <span>{{fee.serviceFee}}元</span>
      </div>
      <div>
        <span>加价:</span>
        <span>{{addFee ? addFee : '0.00'}}元</span>
      </div>
      <div v-if="budget != 0">
        <span>票价:</span>
        <span>{{budget}}元</span>
      </div>
      <div v-if="payType ? false : true">
        <span>诊金:</span>
        <span>{{fee.diagnosisFee ? fee.diagnosisFee : '0.00' }}元</span>
      </div>
      <div class="pay">
        <span>应支付金额:</span>
        <span class="totalPrice">{{payFee}}元</span>
      </div>
      <p class="night">溢价：{{fee.premiumFee ? fee.premiumFee : '0.00'}}元</p>
      <p class="night" v-if="$route.name == 'ConfirmOrder' && expressType == 0">夜间服务费：{{fee.nightPrice ? fee.nightPrice : '0.00'}}元</p>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    payFee () {
      return this.$store.getters.payFee()
    },
    ...mapState(['amount', 'fee', 'addFee', 'payType', 'expressType', 'budget']),
    ...mapGetters(['payFee'])
  },
  deactivated() {
    console.log(this.$route.path)
    if(this.$route.path == '/home/richText' || this.$route.path == '/home/richText') return false
    this.$store.dispatch('clearCouponAmount')
    this.$store.dispatch('clearAddFee')
    this.$store.dispatch('clearFee')
    this.$store.dispatch('clearBudget')
  },
  destroyed() {
    console.log(this.$route.path)
    if(this.$route.path == '/home/richText') return
    this.$store.dispatch('clearCouponAmount')
    this.$store.dispatch('clearAddFee')
    this.$store.dispatch('clearFee')
    this.$store.dispatch('clearBudget')
  }
}
</script>

<style scoped lang="less" type="text/less">
.pricePlain{
  .info{
    width: 569px;
    box-sizing: border-box;
    margin-top:19px;
    padding:30px 30px 20px;
    border:4px solid #f1f1f1;
    div{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      font-size: 16px;
      &.pay{
        font-size: 20px;
        margin-bottom: 14px;
        .totalPrice{
          color:#E60012;
        }
      }
    }
    .night{
      text-align: right;
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Courier/PriceExplain.vue